import { type FC, type PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import { SPECIAL_OFFERS_HEADER_ID } from '@bridebook/web/app-shared/components/supplier/sections/ids';
import styles from './logged-out-top-section-heading.style';

const LoggedOutTopSectionHeading: FC<PropsWithChildren> = ({ children }) => (
  <Box id={SPECIAL_OFFERS_HEADER_ID} as="h2" style={styles.header}>
    {children}
  </Box>
);

export default LoggedOutTopSectionHeading;
